// extracted by mini-css-extract-plugin
export default {"block":"block___XwLJH","btn":"btn___O9mIe"};